/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnalyticsBreakdownDto } from '../../models/analytics-breakdown-dto';

export interface SuperadminControllerGetAnalyticsBreakdown$Params {
  from?: string;
  to?: string;
  event?: 'registration_start' | 'registration_completed' | 'paywall_shown' | 'upgrade_modal_opened' | 'checkout_started' | 'checkout_failed' | 'purchase_completed' | 'subscription_canceled';
  dimension?: 'platform' | 'appVersion' | 'env' | 'utmSource' | 'utmMedium' | 'utmCampaign';
}

export function superadminControllerGetAnalyticsBreakdown(http: HttpClient, rootUrl: string, params?: SuperadminControllerGetAnalyticsBreakdown$Params, context?: HttpContext): Observable<StrictHttpResponse<AnalyticsBreakdownDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerGetAnalyticsBreakdown.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('event', params.event, {});
    rb.query('dimension', params.dimension, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AnalyticsBreakdownDto>;
    })
  );
}

superadminControllerGetAnalyticsBreakdown.PATH = '/superadmin/analytics/breakdown';
